/**
 * Check is given value is a non-empty string (after trimming) and returns it trimmed.
 *
 * @param value Any type of value
 * @returns String if value is non-empty string (after trimming), undefined otherwise
 */
const stringOrUndefined = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmedValue = value.trim();
  return trimmedValue || undefined;
};

export default stringOrUndefined;
